import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { FilesRoute } from './FilesRoute';
import { ViewerPage } from './ViewerPage';
import { ALBUMS, LIB_DOCS, MY_FILES, SHARED_FILES } from './fixtures';

/** Tệp & tài liệu (Mint-Files): tab "Tệp của tôi", "Tài liệu công ty", "Media" (?tab=my|lib|media). */
const files: EzyModule = {
  // Chưa có nav: board đặt Tệp trong nhóm "Thư viện › Tài liệu & media" (nhóm của luồng H / kb); route `/ezy/files` mở được ngay.
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/files', component: FilesRoute }),
    // Mint-FileViewer: ?kind=pdf|image|office|text|mail|gallery&f=<chỉ số tệp job>&state=…
    createRoute({ getParentRoute: () => parent, path: '/files/view', component: ViewerPage }),
  ],
  fixtures: (register) => {
    register('file', MY_FILES);
    register('fileShared', SHARED_FILES);
    register('libDoc', LIB_DOCS);
    register('fileAlbum', ALBUMS);
  },
};
export default files;
